import { Chip, Divider, Skeleton } from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import * as React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import { ClientCalendar } from '../Calendar';
import { Documents } from '../Documents/Documents';
import SocialEngagementTab from '../SocialEngagementTab/SocialEngagementTab';
import AtheleteDetails from './AtheleteDetails';
import BusinessDetails from './BusinessDetails';
import style from './ClientSelected.module.css';
import TalentDetails from './TalentDetails';

import CustomButton from 'components/shared/CustomButton/CustomButton';
import CustomCard from 'components/shared/CustomCard/CustomCard';
import ActivityTab from 'components/shared/CustomDashboard/ActivityTab/ActivityTab';
import ContactTab from 'components/shared/CustomDashboard/ContactsTab/ContactTab';
import KeyDealsTab from 'components/shared/CustomDashboard/KeyDealsTab/KeyDealsTab';
import ActivityColumn from 'components/shared/CustomDashboard/Overview/Activity/ActivityColumn';
import DashboardDealCard from 'components/shared/CustomDashboard/Overview/DashboardDealCard';
import KeyDeals from 'components/shared/CustomDashboard/Overview/KeyDeals';
import OverviewTab from 'components/shared/CustomDashboard/Overview/OverviewTab';
import SocialEngagement from 'components/shared/CustomDashboard/Overview/SocialEngagement';
import TaskColumn from 'components/shared/CustomDashboard/Overview/Tasks/TaskColumn';
import TaskTab from 'components/shared/CustomDashboard/TaskTab/TaskTab';
import CustomDrawer from 'components/shared/CustomDrawer/CustomDrawer';
import CustomHomepage from 'components/shared/CustomHomePage/CustomHomepage';
import CustomModal from 'components/shared/CustomModal/CustomModal';
import CustomPopOver from 'components/shared/CustomPopOver/CustomPopOver';
import { LightTooltip } from 'components/shared/CustomTooltip/CustomTooltip';

import ClientDrawer from 'pages/Dashboard/Client/ClientForm/FormDrawer/ClientDrawer';
import LinkingForm from 'pages/Dashboard/Client/ClientForm/Forms/LinkingForm';

import { ClientService } from 'service/client.service';
import { DashboardService } from 'service/dashboard.service';
import { HuddleClientService } from 'service/huddle-client.service';

import formatCurrency from 'helper/short-currency';
import zeplinColor from 'theme/Color';

import { ClientType, Constants } from 'utilities/constants';

type SportsProps = {
  link: '';
  title: '';
  source: '';
};

const ClientSelected = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const client = location.state?.client;
  const sf_token = sessionStorage.getItem('SFToken') || '';
  const new_client = sessionStorage.getItem('new-client') || '';
  const captive8IdStored = sessionStorage.getItem('captive8Id');
  const sf_delete = sessionStorage.getItem('sf_delete') || '';
  const sf_edit = sessionStorage.getItem('sf_edit') || '';
  const captive8UrlStored = sessionStorage.getItem('captive8Url');
  const currentTab = sessionStorage.getItem('currentTab') || '0';
  const sf_redirect = sessionStorage.getItem('sf_redirect') || '';

  const [value, setValue] = React.useState(0);
  const [alert, setAlert] = React.useState('');
  const [drawerState, setDrawerState] = React.useState(false);
  const splitPath = location.pathname?.split('/');
  const clientId = splitPath?.includes('huddle') ? splitPath[3] : splitPath[2];
  const onClose = (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
    if (
      event.type === 'keydown' &&
      ((event as React.KeyboardEvent).key === 'Tab' ||
        (event as React.KeyboardEvent).key === 'Shift')
    ) {
      return;
    }
    setDrawerState(open);
  };
  const onOpen = () => {
    setDrawerState(true);
  };

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    sessionStorage.setItem('currentTab', newValue.toString());
    sessionStorage.removeItem('dealSelectedFromOverview');
    setValue(newValue);
  };

  const handleClose = () => {
    setAlert('');
  };

  const [data, setData] = React.useState<any>();
  const [details, setDetails] = React.useState<any>();
  const [loading, setLoading] = React.useState(false);
  const [openModal, setOpenModal] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState<HTMLDivElement | null>(null);
  const [action, setAction] = React.useState('');
  const [captive8loading, setCaptive8Loading] = React.useState(false);
  const [creatorInfo, setCreatorInfo] = React.useState<any>(null);
  const [editModal, setEditModal] = React.useState(false);
  const [linkModal, setLinkModal] = React.useState(false);
  const [sportsData, setSportsData] = React.useState<SportsProps[]>([
    {
      link: '',
      title: '',
      source: '',
    },
  ]);

  const handleCopyLink = (val: any) => {
    navigator.clipboard.writeText(val);
    setAlert('Link Copied');
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const getDetails = async (id: string) => {
    setLoading(true);
    try {
      if (id) {
        const res = location?.pathname?.includes('huddle')
          ? await HuddleClientService.getClientHuddleDetails(id)
          : await ClientService.getClientDetails(id);
        getCreatorInfo(res?.captiv8Id || res?.captive8CreatorId);

        setDetails({ accountName: res?.name, accountType: res?.recordType, ...res });
      }
    } catch (err: any) {
      setAlert(err?.message as string);
    } finally {
      setLoading(false);
    }
  };

  const getDeal = async (id: string) => {
    try {
      const res = location?.pathname?.includes('huddle')
        ? await HuddleClientService.getHuddleClientDeal(id)
        : await ClientService.getClientDeal(id);

      setData(res);
    } catch (err: any) {
      setAlert(err?.message as string);
    }
  };

  const getSportNews = async () => {
    try {
      const res: { latestNews: SportsProps[] } = await DashboardService.getSportNews();

      setSportsData(res?.latestNews);
    } catch (err: any) {
      setAlert(`sports api : ${err?.message as string}`);
    }
  };

  const getCreatorInfo = async (id: string) => {
    try {
      if (id) {
        setCaptive8Loading(true);
        const res = await ClientService.getCreatorInfo(id);
        setCreatorInfo(res);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setCaptive8Loading(false);
    }
  };

  React.useEffect(() => {
    getDeal(clientId || '');
    getSportNews();
    getDetails(clientId || '');

    new_client === 'true' && setLinkModal(true);
    sf_redirect === 'Task' && setValue(2);
    sf_redirect === 'Overview' && setValue(0);
    sf_redirect === 'Deals' && setValue(3);
    sf_redirect === 'Activity' && setValue(1);
    if (!sf_redirect) {
      setValue(+currentTab || 0);
    }
  }, [clientId]);

  React.useEffect(() => {
    const handleSFTokenAuth = (e: CustomEvent) => {
      if (e.detail.key === 'SFToken') {
        if (e.detail.value === 'true' && !openModal) {
          sf_delete === 'true' && handleOpen();
          sf_edit === 'true' && setEditModal(true);
        }
      }
    };

    window.addEventListener('sessionStorageChange', handleSFTokenAuth as EventListener);

    return () => {
      window.removeEventListener('sessionStorageChange', handleSFTokenAuth as EventListener);
    };
  }, []);
  const handleOpen = () => setOpenModal((prev) => !prev);

  const DashboardTabs = [
    {
      label: 'Overview',
      id: 1,
      isHidden: value !== 0,
      Component: (
        <Box>
          <OverviewTab
            channelID={client?.slackChannelId}
            setActiveTab={setValue}
            Column1={ActivityColumn}
            Column2={TaskColumn}
            Column3={SocialEngagement}
            creatorInfo={creatorInfo}
            AlternatColumn3={SocialEngagement}
            Column4={KeyDeals}
            setValue={setValue}
            captive8Url={client?.captive8Url}
            captive8Loading={captive8loading}
          />
        </Box>
      ),
    },
    {
      label: 'Activity',
      id: 2,
      isHidden: value !== 1,
      Component: (
        <Box>
          <ActivityTab />
        </Box>
      ),
    },
    {
      label: 'Task',
      id: 3,
      isHidden: value !== 2,
      Component: (
        <Box>
          <TaskTab />
        </Box>
      ),
    },
    {
      label: 'Deals',
      id: 4,
      isHidden: value !== 3,
      Component: (
        <Box>
          <KeyDealsTab getDeal={() => getDeal(clientId || '')} />
        </Box>
      ),
    },
    {
      label: 'Social Engagement',
      id: 5,
      isHidden: value !== 4,
      Component: (
        <Box>
          <SocialEngagementTab
            key={details?.captive8CreatorId || details?.captive8Id || captive8IdStored}
            captive8Id={details?.captiv8Id || captive8IdStored}
            captive8Url={details?.captive8Url || captive8UrlStored}
            getDetails={() => {
              getDetails(clientId || '');
            }}
          />
        </Box>
      ),
    },
    {
      label: 'Contacts',
      id: 6,
      isHidden: value !== 5,
      Component: (
        <Box>
          <ContactTab />
        </Box>
      ),
    },
    {
      label: 'Documents',
      id: 7,
      isHidden: value !== 6,
      Component: (
        <Box sx={{ height: '100%' }}>
          <Documents />
        </Box>
      ),
    },
    {
      label: 'Calendar',
      id: 8,
      isHidden: value !== 7,
      Component: (
        <Box sx={{ height: '100%' }}>
          <ClientCalendar />
        </Box>
      ),
    },
  ];

  const handleDeleteClick = (event: React.MouseEvent<HTMLDivElement>) => {
    if (
      sf_token === 'true' ||
      details?.source === 'Huddle' ||
      location?.pathname?.includes('huddle')
    ) {
      handleOpen();
    } else {
      setAnchorEl(event.currentTarget);
      setAction('delete');
    }
  };

  const handleEditModal = (event: React.MouseEvent<HTMLDivElement>) => {
    if (
      sf_token === 'true' ||
      details?.source === 'Huddle' ||
      location?.pathname?.includes('huddle')
    ) {
      setEditModal(true);
    } else {
      setAnchorEl(event.currentTarget);
      setAction('edit');
    }
  };

  const editForm = (
    <ClientDrawer
      drawerState={editModal}
      typeSelected={details?.accountType?.split('_').join(' ')}
      data={details}
      setDrawerState={setEditModal}
      getAllClient={() => getDetails(clientId || '')}
    />
  );

  const handleDeleteConfirm = async (id: string) => {
    try {
      setLoading(true);
      location?.pathname?.includes('huddle')
        ? await HuddleClientService.deleteHuddleClient(id)
        : await ClientService.deleteClient(id);
      sessionStorage.removeItem('sf_delete');
      navigate('/clients');
    } catch (err) {
      setAlert('Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <CustomHomepage
        CTA={
          value === 0 ? (
            <LightTooltip
              title={
                <Typography variant='responsiveBody3' color={zeplinColor.Neutral1}>
                  Manage Integrations
                </Typography>
              }
              placement='bottom-end'
              style={{ backgroundColor: zeplinColor.BasicBlack, borderRadius: '8px' }}
            >
              <Box
                sx={{ width: '100%' }}
                onClick={() => {
                  setLinkModal(true);
                }}
              >
                <CustomCard
                  styles={{
                    borderRadius: { xs: '10px', xl: '14px' },
                    padding: '15px 12px',
                    backgroundColor: zeplinColor.Neutral1,
                    ':hover': {
                      backgroundColor: zeplinColor.Neutral4,
                    },
                    border: `1px solid ${zeplinColor.BasicBlack}`,
                    cursor: 'pointer',
                    height: { xs: 30, xl: 48 },
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    flex: 1,
                    gap: '8px',
                  }}
                  aria-label='button'
                >
                  <img src='/assets/manage-icon.svg' width={20} height={20} alt='manage-settings' />
                  <Typography variant='responsiveButtonSmall' color={zeplinColor.BasicBlack}>
                    Manage Integrations
                  </Typography>
                </CustomCard>
              </Box>
            </LightTooltip>
          ) : (
            <></>
          )
        }
        sportsData={sportsData}
        ProfileDetails={
          <Box sx={{ display: 'flex', gap: '16px' }}>
            <Box
              sx={{
                width: { xs: '80px', xl: '100px' },
                height: { xs: '80px', xl: '100px' },
                borderRadius: '14px',
                backgroundColor: zeplinColor.Brand1,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              {captive8loading ? (
                <Skeleton variant='rounded' width={100} height={100} />
              ) : details?.avatar ? (
                <img
                  className={style['avatar']}
                  src={details?.avatar}
                  alt='logo'
                  loading='lazy'
                  style={{ objectFit: 'fill', borderRadius: '14px' }}
                />
              ) : (
                <Typography variant='display4' sx={{ color: zeplinColor.Neutral1 }}>
                  {details?.accountName
                    ?.split(' ')
                    .map((val: any, index: number) =>
                      index === 0 || index === details?.accountName?.split(' ').length - 1
                        ? val[0]
                        : '',
                    )}
                </Typography>
              )}
            </Box>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
              }}
            >
              <Typography
                sx={{ fontSize: { xs: '24px', xl: '36px' }, fontWeight: '300' }}
                color={zeplinColor.Neutral1}
              >
                {details?.accountName}
              </Typography>
              <Box>
                <CustomButton
                  disabled={false}
                  variant='text'
                  text={'Profile Details'}
                  textStyle={{
                    color: zeplinColor.Neutral1,
                    fontSize: '14px',
                    whiteSpace: 'nowrap',
                  }}
                  onClick={onOpen}
                  style={{
                    border: `1px solid ${zeplinColor.Neutral1}`,
                    borderRadius: '8px',
                    height: '32px',
                    padding: '6px 12px',
                  }}
                />
              </Box>
            </Box>
          </Box>
        }
        DealCard={
          <Box sx={{ display: 'flex', gap: '16px', flex: 1 }}>
            <DashboardDealCard
              color={Constants.DealsColor.totalDealsWon}
              val={
                +data?.totalDealsWon >= 0
                  ? `$${formatCurrency(data?.totalDealsWon) ?? 0}`
                  : undefined
              }
              percent={data?.dealsWonDelta || 0}
              text={Constants.DealsText.totalDealsWon}
            />
            <DashboardDealCard
              color={Constants.DealsColor.totalOpenDeals}
              val={
                +data?.totalOpenDeals >= 0
                  ? `$${formatCurrency(data?.totalOpenDeals) ?? 0}`
                  : undefined
              }
              percent={data?.openDealsDelta || 0}
              text={Constants.DealsText.totalOpenDeals}
            />

            <DashboardDealCard
              color={Constants.DealsColor.totalTasks}
              val={data?.totalTasks}
              text={Constants.DealsText.totalTasks}
            />
            {location?.pathname?.includes('huddle') ? (
              <CustomCard
                styles={{
                  borderRadius: '16px',
                  padding: '24px',
                  backgroundColor: zeplinColor.Neutral10,
                  width: '120px',
                  height: '115px',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Typography variant='body3'>HUDDLE</Typography>
              </CustomCard>
            ) : (
              <Link
                to={`https://${process.env.REACT_APP_SALESFORCE_URI}/lightning/page/home`}
                target='_blank'
                rel='noopener noreferrer'
                style={{ color: zeplinColor.Neutral1, textDecoration: 'none' }}
              >
                <CustomCard
                  styles={{
                    borderRadius: '16px',
                    padding: '24px',
                    backgroundColor: zeplinColor.Neutral10,
                    width: '120px',
                    height: '115px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-end',
                    justifyContent: 'space-between',
                  }}
                >
                  <img src='/assets/link.svg' width={32} height={32} alt='link indicator' />
                  <Typography variant='body3'>Salesforce</Typography>
                </CustomCard>
              </Link>
            )}
          </Box>
        }
        DashboardTabs={DashboardTabs}
        handleChange={handleChange}
        value={value}
        alert={alert}
        handleClose={handleClose}
        Children={
          editModal ? (
            editForm
          ) : (
            <CustomDrawer state={drawerState} onClose={onClose(false)}>
              <Box sx={{ width: { xs: '427px', xl: '527px' }, position: 'relative' }}>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    padding: { xs: '30px 20px 20px 20px', xl: '40px 24px 24px 24px' },
                  }}
                >
                  <Typography variant='responsiveHeading2'>Profile Details</Typography>
                  <img
                    src={'/assets/close-icon.svg'}
                    className={style['icon']}
                    alt='close'
                    style={{ cursor: 'pointer' }}
                    onClick={onClose(false)}
                  />
                </Box>
                <Divider component='div' sx={{ borderColor: zeplinColor.Neutral5 }} />
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: { xs: '18px', xl: '24px' },
                  }}
                >
                  {' '}
                  <Box
                    sx={{
                      display: 'flex',
                      gap: { xs: '10px', xl: '16px' },
                      padding: { xs: '20px 20px 0px 20px', xl: '24px 24px 0px 24px' },
                    }}
                  >
                    <Box
                      sx={{
                        width: { xs: '55px', xl: '60px' },
                        height: { xs: '55px', xl: '60px' },
                        borderRadius: '14px',
                        backgroundColor: client?.avatar ? zeplinColor.Neutral1 : zeplinColor.Brand1,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                    >
                      {captive8loading ? (
                        <Skeleton variant='rounded' width={60} height={60} />
                      ) : client?.avatar ? (
                        <img
                          className={style['profile-section-avatar']}
                          src={client?.avatar}
                          alt='logo'
                          loading='lazy'
                          style={{ objectFit: 'fill', borderRadius: '14px' }}
                        />
                      ) : (
                        <Typography
                          variant='responsiveDisplay4'
                          sx={{ color: zeplinColor.Neutral1 }}
                        >
                          {details?.accountName
                            ?.split(' ')
                            .map((val: any, index: number) =>
                              index === 0 || index === details?.accountName?.split(' ').length - 1
                                ? val[0]
                                : '',
                            )}
                        </Typography>
                      )}
                    </Box>
                    <Box
                      sx={{
                        display: 'flex',
                        gap: '12px',
                        justifyContent: 'space-between',
                        alignItems: 'flex-start',
                        flex: 1,
                      }}
                    >
                      <Box
                        sx={{
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'space-between',
                          flex: 1,
                        }}
                      >
                        <Box
                          sx={{
                            display: 'flex',
                          }}
                        >
                          <Box sx={{ display: 'flex', gap: '8px' }}>
                            <LightTooltip
                              title={
                                <Typography variant='responsiveBody3' color={zeplinColor.Neutral1}>
                                  {details?.accountName}
                                </Typography>
                              }
                              placement='bottom-start'
                              style={{
                                backgroundColor: zeplinColor.BasicBlack,
                                borderRadius: '8px',
                              }}
                            >
                              <Typography
                                variant='responsiveDisplay5'
                                color={zeplinColor.BasicBlack}
                                style={{
                                  textDecoration: 'none',
                                  display: 'inline-block',
                                  maxWidth: '220px',
                                  overflow: 'hidden',
                                  whiteSpace: 'nowrap',
                                  textOverflow: 'ellipsis',
                                  verticalAlign: 'middle',
                                }}
                              >
                                {details?.accountName}
                              </Typography>
                            </LightTooltip>
                            {details?.league ? (
                              <Chip
                                label={
                                  <Typography
                                    variant='responsiveLabel1'
                                    color={zeplinColor.Neutral1}
                                    sx={{
                                      textAlign: 'center',
                                      display: 'flex',
                                      justifyContent: 'center',
                                      alignItems: 'center',
                                    }}
                                  >
                                    {details?.league ?? 'NA'}
                                  </Typography>
                                }
                                sx={{
                                  backgroundColor: zeplinColor.BasicBlack,
                                  padding: '5px 12px 5px 12px',
                                  borderRadius: '50px',
                                  height: '24px',
                                }}
                              />
                            ) : (
                              ''
                            )}
                          </Box>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            justifyContent: 'flex-start',
                          }}
                        >
                          {!location?.pathname?.includes('huddle') && (
                            <Link
                              to={`https://${process.env.REACT_APP_SALESFORCE_URI}/lightning/r/Account/${clientId}/view`}
                              target='_blank'
                              rel='noopener noreferrer'
                              style={{
                                color: zeplinColor.BasicBlack,
                                textDecoration: 'none',
                                cursor: 'pointer',
                              }}
                            >
                              <CustomCard
                                styles={{
                                  borderRadius: '50px',
                                  padding: '10px 10px 10px 0px',
                                  backgroundColor: zeplinColor.Neutral1,
                                  border: `0px solid ${zeplinColor.Neutral6}`,
                                  display: 'flex',
                                  gap: '4px',
                                  alignItems: 'flex-end',
                                  justifyContent: 'space-between',
                                  cursor: 'pointer',
                                }}
                              >
                                <Typography variant='responsiveBody3' color={zeplinColor.Brand1}>
                                  Salesforce
                                </Typography>
                                <img
                                  src='/assets/link-blue.svg'
                                  className={style['link']}
                                  alt='link indicator'
                                />
                              </CustomCard>
                            </Link>
                          )}
                        </Box>
                      </Box>
                      <Box
                        sx={{
                          display: 'flex',
                          gap: { xs: '10px', xl: '16px' },
                          alignItems: 'center',
                        }}
                      >
                        <img
                          src={'/assets/edit.svg'}
                          className={style['icon']}
                          alt='edit'
                          style={{ cursor: 'pointer' }}
                          onClick={handleEditModal}
                        />
                        {!location?.pathname?.includes('huddle') && (
                          <img
                            src={'/assets/copy-view.png'}
                            className={style['icon']}
                            alt='copy'
                            style={{ cursor: 'pointer' }}
                            onClick={() =>
                              handleCopyLink(
                                `https://${process.env.REACT_APP_SALESFORCE_URI}/lightning/r/Account/${clientId}/view`,
                              )
                            }
                          />
                        )}
                        <img
                          src={'/assets/delete-red.png'}
                          className={style['icon']}
                          alt='close'
                          style={{ cursor: 'pointer' }}
                          onClick={handleDeleteClick}
                        />
                      </Box>
                    </Box>
                    <CustomPopOver
                      setAnchorEl={setAnchorEl}
                      anchorEl={anchorEl}
                      id={id}
                      sx={{
                        borderRadius: '14px',
                        boxShadow: 'rgba(0, 0, 0, 0.15)',
                        marginTop: '8px',
                      }}
                    >
                      <Box
                        sx={{
                          height: '202px',
                          width: '340px',
                          padding: '24px',
                          display: 'flex',
                          gap: '32px',
                          flexDirection: 'column',
                        }}
                      >
                        <Box
                          sx={{
                            display: 'flex',
                            gap: { xs: '10px', xl: '16px' },
                            flexDirection: 'column',
                          }}
                        >
                          <Box
                            sx={{
                              display: 'flex',
                              gap: { xs: '6px', xl: '12px' },
                              justifyContent: 'space-between',
                            }}
                          >
                            <Typography variant='responsiveHeading3' color={zeplinColor.BasicBlack}>
                              Authentication Required
                            </Typography>
                            <img
                              src={'/assets/close-icon.svg'}
                              className={style['icon']}
                              alt='close'
                              style={{ cursor: 'pointer' }}
                              onClick={() => {
                                setAnchorEl(null);
                              }}
                            />
                          </Box>

                          <Typography variant='responsiveBody3' color={zeplinColor.BasicBlack}>
                            You need to be logged into Salesforce to perform this action. Please log
                            in to your Salesforce account.
                          </Typography>
                        </Box>
                        <Link
                          to={`https://${process.env.REACT_APP_SALESFORCE_URI}/services/oauth2/authorize?client_id=${process.env.REACT_APP_CLIENT_SALESFORCE}&redirect_uri=${process.env.REACT_APP_REDIRECT}&response_type=code`}
                        >
                          <CustomButton
                            disabled={false}
                            onClick={() => {
                              setOpenModal(false);
                              sessionStorage.setItem('sf_redirect', 'Task');
                              sessionStorage.setItem('sf_path', location?.pathname);
                              action === 'edit'
                                ? sessionStorage.setItem('sf_edit', 'true')
                                : sessionStorage.setItem('sf_delete', 'true');
                            }}
                            variant='contained'
                            color={'primary'}
                            style={{
                              width: '155px',
                              borderRadius: '14px',
                              height: '48px',
                              padding: '14px 16px',
                              '&.Mui-focusVisible': { backgroundColor: '#333CAA' },
                            }}
                            textStyle={{ color: zeplinColor.Neutral1 }}
                            text={'Open Salesforce'}
                          />
                        </Link>
                      </Box>
                    </CustomPopOver>
                  </Box>
                  {details?.accountType?.split('_').join(' ') === ClientType?.Talent && (
                    <TalentDetails loading={loading} details={details} />
                  )}
                  {details?.accountType?.split('_').join(' ') === ClientType?.Athlete && (
                    <AtheleteDetails loading={loading} details={details} />
                  )}
                  {details?.accountType?.split('_').join(' ') === ClientType?.Business && (
                    <BusinessDetails loading={loading} details={details} />
                  )}
                </Box>
              </Box>
            </CustomDrawer>
          )
        }
      />
      <CustomModal handleClose={() => setOpenModal(false)} open={openModal}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
          }}
        >
          <CustomCard
            styles={{
              borderRadius: '14px',
              padding: { xs: '20px', xl: '24px' },
              backgroundColor: zeplinColor.Neutral1,
              boxShadow: 'rgba(0, 0, 0, 0.15)',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: { xs: '22px', xl: '32px' },
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: { xs: '10px', xl: '16px' },
                }}
              >
                <Typography variant='heading3' color={zeplinColor.BasicBlack}>
                  Delete Client?
                </Typography>
                <Typography variant='body2' color={zeplinColor.BasicBlack}>
                  You’re about to permanently delete{' '}
                  <Typography variant='responsiveHeading4'>{details?.accountName}</Typography>
                  <br /> and all related data. This action can’t be
                  <br /> undone. Are you sure you want to proceed?
                </Typography>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  gap: { xs: '10px', xl: '16px' },
                }}
              >
                <Box
                  onClick={() => {
                    setOpenModal(false);
                    sessionStorage.removeItem('sf_delete');
                  }}
                  sx={{ flex: 1, display: 'flex', justifyContent: 'center' }}
                >
                  <CustomCard
                    styles={{
                      borderRadius: '14px',
                      padding: '14px 32px',
                      backgroundColor: zeplinColor.Neutral1,
                      border: `1px solid ${zeplinColor.BasicBlack}`,
                      cursor: 'pointer',
                      display: 'flex',
                      justifyContent: 'center',
                      flex: 1,
                    }}
                    aria-label='button'
                    aria-disabled={loading}
                  >
                    <Typography variant='buttonMedium' color={zeplinColor.BasicBlack}>
                      Cancel
                    </Typography>
                  </CustomCard>
                </Box>
                <Box
                  onClick={() => {
                    handleDeleteConfirm(details?.accountId);
                  }}
                  sx={{ flex: 1, display: 'flex', justifyContent: 'center' }}
                >
                  <CustomCard
                    styles={{
                      borderRadius: '14px',
                      padding: '14px 32px',
                      backgroundColor: zeplinColor.Error,
                      cursor: 'pointer',
                      display: 'flex',
                      justifyContent: 'center',
                      flex: 1,
                    }}
                    aria-label='button'
                    aria-disabled={loading}
                  >
                    <Typography
                      variant='buttonMedium'
                      color={zeplinColor.Neutral1}
                      sx={{ whiteSpace: 'nowrap', textAlign: 'center' }}
                    >
                      {loading ? 'Deleting...' : 'Delete'}
                    </Typography>
                  </CustomCard>
                </Box>
              </Box>
            </Box>
          </CustomCard>
        </Box>
      </CustomModal>
      <LinkingForm
        modalOpen={linkModal}
        key={linkModal?.toString()}
        setLinkModal={setLinkModal}
        clientId={client?.AccountId}
        client={details || client}
        getAllClient={() => {
          getDetails(clientId || '');
        }}
      />
    </>
  );
};

export default ClientSelected;
